import { utils, writeFile, read } from "xlsx-with-styles";

class VueExcelEco2 {
  columns: Array<any>;
  data: Array<any>;
  fileName: string;
  sheetName: string;
  fileType: "xlsx" | "xls";

  constructor(
    fileName: string,
    fileType: "xlsx" | "xls",
    sheetName: string,
    data: Array<any>,
    columns: Array<any>
  ) {
    this.fileName = fileName;
    this.fileType = fileType;
    this.sheetName = sheetName;
    this.columns = columns;
    this.data = data;
  }

  exportExcel() {
    let createXLSLFormatObj = [];
    let newXlsHeader = [];
    if (this.columns.length === 0) {
      console.log("Add columns!");
      return;
    }
    if (this.data.length === 0) {
      console.log("Add data!");
      return;
    }
    this.columns.map((column) => {
      newXlsHeader.push(column.label);
    });

    createXLSLFormatObj.push(newXlsHeader);
    this.data.map((value) => {
      let innerRowData = [];
      this.columns.map((val) => {
        let fieldValue = value[val.field] === 0 ? "0" : value[val.field] || "";
        if (val.field.split(".").length > 1) {
          fieldValue = this.getNestedValue(value, val.field);
        }
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(fieldValue));
        } else {
          innerRowData.push(fieldValue);
        }
      });
      createXLSLFormatObj.push(innerRowData);
    });

    let fileName = this.fileName + "." + this.fileType;

    let ws_name = this.sheetName;

    let wb = utils.book_new();
    let ws = utils.aoa_to_sheet(createXLSLFormatObj);

    this.applyStyleByWorkSheet(ws);

    utils.book_append_sheet(wb, ws, ws_name);
    writeFile(wb, fileName);
  }

  getNestedValue(object, str) {
    str = str.replace(/\[(\w+)\]/g, ".$1");
    str = str.replace(/^\./, "");
    let a = str.split(".");
    for (let i = 0, n = a.length; i < n; ++i) {
      let k = a[i];
      if (object == null) return;
      if (k in object) {
        object = object[k];
      } else {
        return;
      }
    }
    return object;
  }

  applyStyleByWorkSheet(ws) {
    for (let i in ws) {
      if (typeof ws[i] != "object") continue;
      let cell = utils.decode_cell(i);

      //  styling for all cells
      ws[i].s = {
        font: this.fontStyleCells,
        alignment: this.alignmentCells,
        border: this.borderStyle,
      };

      if (cell.c == 0) {
        // first column
      }

      if (cell.r == 0) {
        // first row
        ws[i].s = this.headerStyle;
      }

      if (cell.r % 2) {
      }
    }
  }

  borderStyle = {
    right: {
      style: "thin",
      color: "000000",
    },
    left: {
      style: "thin",
      color: "000000",
    },
    top: {
      style: "thin",
      color: "000000",
    },
    bottom: {
      style: "thin",
      color: "000000",
    },
  };

  headerStyle = {
    font: {
      name: "Times New Roman",
      sz: 12,
      bold: true,
    },
    alignment: {
      vertical: "center",
      horizontal: "center",
    },
    fill: {
      fgColor: { rgb: "B6D7A8" },
    },
    border: this.borderStyle,
  };

  fontStyleCells = {
    name: "Arial",
    sz: 11,
  };

  alignmentCells = {
    vertical: "center",
    horizontal: "center",
  };
}

export { VueExcelEco2 };
